<form class="filter-bar" [formGroup]="form" aria-label="Filtros de adesão de integração">
  <div class="row g-3">
    <div class="col-12 col-md-4">
      <label class="filter-label" for="filtro-integracao-participante">Procure por participante</label>
      <input
        id="filtro-integracao-participante"
        type="search"
        class="form-control filter-control"
        formControlName="participante"
        placeholder="Nome, matrícula ou registro"
        autocomplete="off"
        data-testid="filtro-integracao-participante"
      />
    </div>

    <div class="col-12 col-md-3">
      <label class="filter-label" for="filtro-integracao-status">Status</label>
      <select
        id="filtro-integracao-status"
        class="form-select filter-control"
        formControlName="status"
        data-testid="filtro-integracao-status"
      >
        @for (option of statusOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
    </div>

    <div class="col-12 col-md-5">
      <label class="filter-label" for="filtro-integracao-data">Data</label>
      <input
        id="filtro-integracao-data"
        type="date"
        class="form-control filter-control"
        formControlName="data"
        data-testid="filtro-integracao-data"
      />
    </div>
  </div>
</form>
